export enum RenderPass {
    Background,
    Opaque,
}
